// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"344":"7d7a478b","562":"e7d05ef6","761":"ba81b096"}[chunkId] + ".chunk.js";
};